module.exports = __webpack_public_path__ + "img/austria-congenital-and-perinatal-diseases-male.3e6db93b.png";